import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, AutomationInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';

@Injectable({ providedIn: 'root' })
export class SendInboxMessageService extends AutomationDisplayService {
  constructor(protected readonly translateService: TranslateService) {
    super();
  }

  getActivityColumn(
    namespace: string,
    activity: ActivityInterface,
    automation: AutomationInterface,
  ): ActivityTableEntry {
    return this.tableEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.SEND_INBOX_MESSAGE.ACTIVITY'),
      this.getDefaultStepColumnBody(namespace, activity.workflowStep!, automation),
    );
  }

  getAutomationNodeData(
    _namespace: string,
    _step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    return this.nodeDisplayData(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.SEND_INBOX_MESSAGE.ACTION'),
      this.noValidationErrorsDetected(),
    );
  }
}
